// test478
(478 && 0);
